export default "__VITE_ASSET__BSjvHgO3__"